//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "TestConditionModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    testCondition: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  watch: {
    showModal: function showModal(value) {
      this.visible = value;
    }
  },
  methods: {
    onConfirm: function onConfirm() {
      this.visible = false;
      this.$emit("update:showModal", false);
    },
    goToCourse: function goToCourse(course) {
      // 开启禁止跨校区购买，不跳转课程详情
      if (!course.isCanBuy) {
        this.$message.warning("暂无访问跨校区课程的权限");
        return;
      }

      if (course.type == 2) {
        this.$router.push({
          name: "PackageDetail",
          params: {
            id: course.course_id
          }
        });
      } else {
        this.$router.push({
          name: "CourseShow",
          params: {
            id: course.course_id
          }
        });
      } // 根据课程id跳转到课程详情页


      this.onConfirm();
    }
  }
};